import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export  class  LocalstorageService {

  constructor() { }

  public static getLocal(key) {
    return localStorage.getItem(key)
  }

  public static setLocal(key,value) {
    return localStorage.setItem(key,value);
  }

  public static logout(key) {
    return localStorage.removeItem(key);
  }

  public static setUrl(key,value) {
    return localStorage.setItem(key,value);
  }

  public static removeURL(key) {
    return localStorage.removeItem(key);
  }

  public static getURL(key) {
    return localStorage.getItem(key)
  }

  public static setLanguage(key,value) {
    return localStorage.setItem(key,value);
  }

  public static removeLanguage(key) {
    return localStorage.removeItem(key);
  }

  public static getLanguage(key) {
    return localStorage.getItem(key)
  }

  public static setPageLoadTime(key,value) {
    return localStorage.setItem(key,value);
  }

  public static getPageLoadTime(key){
    return localStorage.getItem(key);
  }

  public static TokenExpired(token: string) {
    // return localStorage.getItem(token)
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    const iat = (JSON.parse(atob(token.split('.')[1]))).iat;
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;
  }

}
